module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAnUAAAAPCAMAAAC1D8noAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMA84XYZPrhpASgjTcwHAz3dVAkDurQvLYsKBMK7MfGrKqARkFXYvcAAAAAuUlEQVRo3u3VCRKCMBBE0Q6YEECURUXA3b7/Ga3iEFbomneGnvnIXAZj/mZdnKeGCvoqKvB0Gr9un5NlhLZYkPkVmyexuNXwJMcFyoYLWRxgUtJ6Pmboas50O5jE1IF5A1VTkKirnnlkmKCpvlldU/XmaQ9FnTtaXZP1Obkv9Ox8rnlNIpr7sYOa1uqauFh5tRZVVtf0da6FkFhaXbegP5cqQYpoLq8BZgOWMmQ1FdRFsLpuRt/DJOwHntRbF5/Ryj4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/xf/xian.png
// module id = xnpv
// module chunks = 1